import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * File name and type template
 */
export const FileNameTemplate: React.FC<{ fileName: string; fileType: string }> = ({
  fileName,
  fileType,
}) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5 }}>
    <Box>
      <Typography variant="body2" sx={{ fontWeight: 500, color: '#1e293b', fontSize: '0.875rem' }}>
        {fileName}
      </Typography>
      <Typography variant="caption" sx={{ color: '#64748b', fontSize: '0.75rem' }}>
        {fileType}
      </Typography>
    </Box>
  </Box>
);

export default FileNameTemplate;
